import { useCallback, useState } from 'react';
import { CapturedImage } from 'components/CheckInOut/components/CapturedImagePreview';
import { useLocation, useNavigate } from 'react-router';
import useGoogleStorageHelpers from 'utils/helpers/googleStorage.helpers';
import { TrayImagePathParams } from 'api/models/Trays';

type Props = {
  stage?: string;
  trayId?: string;
};

const useCapturedTrayImage = (props?: Props) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const wanted =
    (!props?.stage || props?.stage == state?.capturedFor?.stage) &&
    (!props?.trayId || props?.trayId == state?.capturedFor?.trayId);

  const [capturedImage, setCapturedImage] = useState<CapturedImage | undefined>(
    wanted ? state?.capturedImage : undefined,
  );

  const { constructTrayImagePath, uploadImage } = useGoogleStorageHelpers();

  // returns the gsImagePath
  const uploadCapturedTrayImage = useCallback(
    async (pathParams: TrayImagePathParams): Promise<string> => {
      if (!capturedImage?.dataUri) return '';
      const trayImagePath = constructTrayImagePath(pathParams);
      const gsImagePath = await uploadImage(trayImagePath, capturedImage.dataUri);
      return gsImagePath || '';
    },
    [capturedImage?.dataUri, constructTrayImagePath, uploadImage],
  );

  const clearCapturedTrayImage = useCallback(() => {
    setCapturedImage(undefined);
    navigate(location.pathname, { replace: true, state: null });
  }, [navigate]);

  return { capturedImage, setCapturedImage, uploadCapturedTrayImage, clearCapturedTrayImage };
};

export default useCapturedTrayImage;
